import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./RadioButton.module.css";

type NativeInputProps = Omit<JSX.HTMLAttributes<HTMLInputElement>, "type">;

export default function RadioButton({
    class: cssClass,
    disabled,
    checked,
    style,
    ...nativeInputProps
}: NativeInputProps) {
    return (
        <div
            class={classname(styles.radioButtonWrapper, cssClass, {
                [styles.checked]: checked,
                [styles.disabled]: disabled
            })}
            style={style}>
            <input
                {...nativeInputProps}
                class={styles.radioInput}
                type="radio"
                checked={checked}
                disabled={disabled}/>
            {checked && <div class={styles.checkedCircle}/>}
        </div>
    );
}
